/* ============================================================
   PENGUIN LIQUID-GLASS HEADER — behaviour
   Moved out of the header block. Loaded with defer.
   Changes vs the inline version:
   - No height measuring (heights are fixed in pg-header.css) -> no page jump
   - Cart icon opens Dawn's cart drawer directly
   - Cart badge follows the real cart (Dawn's cart-icon-bubble updates +
     cart-update events), so it stays right after removing items in the
     drawer or adding from "Complete your comfort set"
   ============================================================ */
(function () {
  'use strict';
  var d = document, w = window;
  var root = d.getElementById('PgnRoot');
  if (!root) return;

  /* ---------- 1 · Scroll state ---------- */
  var sentinel = d.getElementById('PgnSentinel');
  if (sentinel && 'IntersectionObserver' in w) {
    new IntersectionObserver(function (entries) {
      root.classList.toggle('is-scrolled', !entries[0].isIntersecting);
    }).observe(sentinel);
  } else {
    var ticking = false;
    w.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        root.classList.toggle('is-scrolled', w.scrollY > 34);
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- 2 · Mobile drawer ---------- */
  var burger   = d.getElementById('PgnBurger'),
      drawer   = d.getElementById('PgnDrawer'),
      backdrop = d.getElementById('PgnBackdrop'),
      hideTimer;

  function openDrawer() {
    clearTimeout(hideTimer);
    backdrop.hidden = false;
    requestAnimationFrame(function () {
      backdrop.classList.add('is-on');
      drawer.classList.add('is-open');
    });
    drawer.setAttribute('aria-hidden', 'false');
    burger.classList.add('is-open');
    burger.setAttribute('aria-expanded', 'true');
    d.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    backdrop.classList.remove('is-on');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    burger.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    d.body.style.overflow = '';
    hideTimer = setTimeout(function () { backdrop.hidden = true; }, 400);
  }
  function closePanels() {
    root.querySelectorAll('.pgn-item.is-open').forEach(function (el) { el.classList.remove('is-open'); });
    root.classList.remove('is-live');
  }

  var isTouch = w.matchMedia('(hover: none)').matches;

  /* ---------- 3 · Cart icon opens Dawn's cart drawer ---------- */
  function openCartDrawer(link) {
    var cartDrawer = d.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open(link);
      return true;
    }
    return false; // no drawer (cart type = page): the link just goes to /cart
  }

  /* ---------- 4 · One delegated click handler ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;

    var cartLink = t.closest('#PgnCartLink');
    if (cartLink) {
      if (openCartDrawer(cartLink)) e.preventDefault();
      return;
    }
    if (t.closest('#PgnBurger')) {
      drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
      return;
    }
    if (t.closest('#PgnClose')) { closeDrawer(); return; }

    var catBtn = t.closest('.pgn-cat__btn');
    if (catBtn && !catBtn.classList.contains('pgn-cat__btn--link')) {
      var cat = catBtn.parentElement, panel = catBtn.closest('.pgn-panel');
      var wasOpen = cat.classList.contains('is-open');
      panel.querySelectorAll('.pgn-cat.is-open').forEach(function (c) {
        c.classList.remove('is-open');
        c.firstElementChild.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) { cat.classList.add('is-open'); catBtn.setAttribute('aria-expanded', 'true'); }
      return;
    }

    if (isTouch) {
      var tl = t.closest('.pgn-item--drop > .pgn-link');
      if (tl) {
        var item = tl.parentElement;
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          closePanels();
          item.classList.add('is-open');
          root.classList.add('is-live');
        }
        return;
      }
    }

    if (t.closest('.pgn-drawer a')) closeDrawer();
  });

  backdrop.addEventListener('click', closeDrawer);

  /* Island leans forward while a dropdown is live */
  if (!isTouch) {
    root.querySelectorAll('.pgn-item--drop').forEach(function (item) {
      item.addEventListener('pointerenter', function () { root.classList.add('is-live'); });
      item.addEventListener('pointerleave', function () { root.classList.remove('is-live'); });
    });
  } else {
    d.addEventListener('click', function (e) {
      if (!e.target.closest('.pgn-item--drop')) closePanels();
    });
  }

  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer.classList.contains('is-open')) closeDrawer();
    closePanels();
  });

  /* ---------- 5 · Cart badge follows the real cart ---------- */
  var countEl = d.getElementById('PgnCartCount');
  var bubble = d.getElementById('cart-icon-bubble');
  var cartJs = ((w.routes && w.routes.cart_url) || '/cart') + '.js';
  var fetchTimer;

  function setCount(n) {
    if (!countEl) return;
    n = parseInt(n, 10) || 0;
    if (String(n) !== countEl.textContent.trim()) {
      countEl.textContent = n;
      countEl.classList.remove('pop');
      void countEl.offsetWidth;
      countEl.classList.add('pop');
    }
    countEl.classList.toggle('is-zero', n === 0);
  }

  function syncFromCart() {
    clearTimeout(fetchTimer);
    fetchTimer = setTimeout(function () {
      fetch(cartJs, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { setCount(cart.item_count); })
        .catch(function () {});
    }, 150);
  }

  // Dawn rewrites #cart-icon-bubble after every add / change / remove.
  function readBubble() {
    if (!bubble) return;
    var badge = bubble.querySelector('.cart-count-bubble');
    if (!badge) { setCount(0); return; }
    var num = badge.querySelector('span[aria-hidden="true"]');
    if (num) setCount(num.textContent); else syncFromCart(); // 100+ items: Dawn hides the number
  }

  if (countEl) {
    countEl.addEventListener('animationend', function () { countEl.classList.remove('pop'); });

    if (bubble && 'MutationObserver' in w) {
      new MutationObserver(readBubble).observe(bubble, { childList: true, subtree: true, characterData: true });
    }

    // Dawn pub/sub (constants.js + pubsub.js load before this file).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, syncFromCart);
    }

    ['cart:refresh', 'cart:updated', 'cart-drawer:open'].forEach(function (evt) {
      d.addEventListener(evt, syncFromCart);
    });

    // Back/forward cache: the page is restored as it was, so re-check.
    w.addEventListener('pageshow', function (e) { if (e.persisted) syncFromCart(); });
  }
})();
